import api from '../index'

export interface baseSubItemQueryRequest {
  _action: string
  _subAction: string
}
export interface Result {
  card_opening_fee: string
  card_service_fee: string
}
export interface rechargesListRequest {
  _action: string
  page: number
  audit_status: number | undefined
  created_at: any
  perPage: number
}
export interface rechargeInfoResult {
  alipayQrcode: string
  bankInfo: {
    bankname: string
    card_number: string
    username: string
  }
  rate: string
  wxQrcode: string
}
export interface submitRechargeRequest {
  money: number
  pay_type: 1 | 2 | 3 | undefined
  voucher: string
}

export interface detailsListRequest {
  _action: string
  page: number
  change_type: number | undefined
  perPage: number
}
export interface rechargeDetailsResult {
  money: string
  exchange_rate: string
  money_cny: string
  pay_type: number
  voucher: string
  audit_status: number
  audit_reason: string
  created_at: string
  updated_at: string
}

export default {
  // 获取充值记录列表
  getRechargesList: (params: rechargesListRequest) => api.get('member-api/recharges', { params }),
  // 获取人民币转美元最新汇率
  getRechargeInfo: () => api.get<rechargeInfoResult>('member-api/recharges', { params: {
    _action: 'getData',
    _subAction: 'getRechargeInfo',
  } }),
  submitRecharge: (data: submitRechargeRequest) => api.post('member-api/recharges', data),
  // 获取充值详情
  getDetails: (params: {
    id: number
  }) => api.get<rechargeDetailsResult>(`member-api/recharges/${params.id}`, {
    params: {
      _action: 'getData',
    },
  }),
  // 获取资金明细
  getDetailsList: (params: detailsListRequest) => api.get('member-api/money-details', { params }),
}
